import $ from 'jquery';
$(function() {
    document.getElementById('copyright').appendChild(document.createTextNode(new Date().getFullYear()));
});
